var exports = {
  "u": "xdde3148b--c6d518--section",
  "D": "xdde3148b--c6d518--title",
};

module.exports = exports;
